import React, { useEffect, useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import FirearmCalibreForm from '../../../components/forms/FirearmCalibreForm';
import { useFirearmCalibreById, useUpdateFirearmCalibre } from '../../../hooks/useFirearmCalibreApi';
import { useNavigate, useParams } from 'react-router-dom';
import Card from '../../../components/common/Card';
import { FirearmCalibreDTO } from '../../../services/apiClient';

const FirearmCalibreEdit: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const { data: entityData, isLoading } = useFirearmCalibreById(id!);
  const updateFirearmCalibre = useUpdateFirearmCalibre();
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Firearm Calibres', href: '/admin/firearmcalibres' },
    { label: 'Edit', href: '#' },
  ];

  const handleSubmit = async (data: any) => {
    try {
      setIsSubmitting(true);
      await updateFirearmCalibre.mutateAsync({ id: id!, data });
      navigate('/admin/firearmcalibres');
    } catch (error) {
      console.error('Error updating FirearmCalibre:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/firearmcalibres"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission='Settings.FirearmCalibre.Edit'
    >
        {entityData ? (
          <FirearmCalibreForm
            initialValues={entityData}
            onSubmit={handleSubmit}
            onCancel={() => navigate('/admin/firearmcalibres')}
          />
        ) : (
          <p>Loading...</p>
        )}
    </AdminLayout>
  );
};

export default FirearmCalibreEdit;